var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.link,"target":"_blank","title":_vm.$t('support')}},[_c('a-icon',{staticClass:"text-muted font-size-14",attrs:{"type":"question-circle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }